import { render, staticRenderFns } from "./xvqiuxq.vue?vue&type=template&id=fa22ff12&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./xvqiuxq.vue?vue&type=script&lang=js&"
export * from "./xvqiuxq.vue?vue&type=script&lang=js&"
import style0 from "./xvqiuxq.vue?vue&type=style&index=0&id=fa22ff12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa22ff12",
  null
  
)

export default component.exports